import { render, staticRenderFns } from "./DriverDataList.vue?vue&type=template&id=babe1ba8&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./DriverDataList.vue?vue&type=script&lang=js&"
export * from "./DriverDataList.vue?vue&type=script&lang=js&"
import style0 from "./DriverDataList.vue?vue&type=style&index=0&id=babe1ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babe1ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
